<template>
     <div class="contenedor-portada-espacio-natural" :id="id"  >
        <div class="contenedor-fondo" >
      <div class="contenedor-imagenes">
        <picture  >
          <source srcset="@/assets/img/scrolly/espacio-natural/fondo.png" media="(min-width: 769px)">
          <img class=img-0 srcset="@/assets/img/scrolly/espacio-natural/fondo-mov.png"  alt="">
        </picture>
        <picture  >
          <source srcset="@/assets/img/scrolly/espacio-natural/1.png" media="(min-width: 769px)">
          <img class=img-1 srcset="@/assets/img/scrolly/espacio-natural/1-mov.png"  alt="">
        </picture>
        <picture  >
          <source srcset="@/assets/img/scrolly/espacio-natural/2.png" media="(min-width: 769px)">
          <img class=img-2 srcset="@/assets/img/scrolly/espacio-natural/2-mov.png" alt="">
        </picture>
        <picture  >
          <source srcset="@/assets/img/scrolly/espacio-natural/3.png" media="(min-width: 769px)">
          <img class=img-3 srcset="@/assets/img/scrolly/espacio-natural/3-mov.png" alt="">
        </picture>
        <picture  >
          <source srcset="@/assets/img/scrolly/espacio-natural/4.png" media="(min-width: 769px)">
          <img class=img-4 srcset="@/assets/img/scrolly/espacio-natural/4-mov.png" alt="">
        </picture>
        <picture  >
          <source srcset="@/assets/img/scrolly/espacio-natural/5.png" media="(min-width: 769px)">
          <img class=img-5 srcset="@/assets/img/scrolly/espacio-natural/5-mov.png" alt="">
        </picture>
        <picture  >
          <source srcset="@/assets/img/scrolly/espacio-natural/5.1.png" media="(min-width: 769px)">
          <img class=img-5-1 srcset="@/assets/img/scrolly/espacio-natural/5.1-mov.png" alt="">
        </picture>
        <picture  >
          <source srcset="@/assets/img/scrolly/espacio-natural/6.png" media="(min-width: 769px)">
          <img class=img-6 srcset="@/assets/img/scrolly/espacio-natural/6-mov.png" alt="">
        </picture>
        <picture  >
          <source srcset="@/assets/img/scrolly/espacio-natural/7.png" media="(min-width: 769px)">
          <img class=img-7 srcset="" alt="">
        </picture>

      </div>
    </div>
     </div>
</template>


<script>
export default {
    props:{
        mostrar:Boolean
  },
}
</script>

<script>
import * as d3 from 'd3';
export default {
  name: 'PortadaEspacioNatural',
  props:{
    paso_inicial:{
      type:Number,
      default:5
    },
    direccion:String,
    id:String,
    
  },
  watch:{
    paso_inicial:function(new_val){
      if(new_val==11){
        d3.select("div#"+this.id)
          .transition()
          .duration(this.tiempo_transicion)
          .style("opacity","1")
        
        d3.select("div#"+this.id)
        .select("div.contenedor-fondo")
          .transition()
          .duration(this.tiempo_transicion)
          .style("width","100%");
        d3.select("div#"+this.id)
          .select("img.img-0")
          .transition()
          .style("opacity","0")
          .delay(2*this.tiempo_transicion)
          .duration(this.tiempo_transicion)
          .style("opacity","1")
          .style("top","0px");

        d3.select("div#"+this.id)
          .select("img.img-1")
          .style("left",window.innerWidth>0?"-100%":"0%")
          .style("top",window.innerWidth>0?"0%":"100%")
          .style("opacity","0")
          .transition()
          .delay(0)
          .duration(1.5*this.tiempo_transicion)
          .style("opacity","1")
          .style("top","0%")
          .style("left","0%");

        d3.select("div#"+this.id)
          .selectAll("img.img-2")
          .style("left",window.innerWidth>0?"-100%":"0%")
          .style("top",window.innerWidth>0?"0%":"100%")
          .style("opacity","0")
          .transition()
          .delay(.5*this.tiempo_transicion)
          .duration(this.tiempo_transicion)
          .style("opacity","1")
          .style("top","0%")
          .style("left","0%");

        d3.select("div#"+this.id)
          .select("img.img-3")
          .style("top",window.innerWidth>0?"-50%":"-50%")
          .style("left",window.innerWidth>0?"10%":"10%")
          .style("opacity","0")
          .transition()
          .delay(1*this.tiempo_transicion)
          .duration(1.5*this.tiempo_transicion)
          .style("opacity","1")
          .style("top","0%")
          .style("left","0%");
        
        d3.select("div#"+this.id)
          .selectAll("img.img-4")
          .style("left",window.innerWidth>0?"50%":"50%")
          .style("top",window.innerWidth>0?"50%":"50%")
          .style("width", "0%")
          .style("height", "0%")
          .style("opacity","0")
          .transition()
          .delay(1.5*this.tiempo_transicion)
          .duration(this.tiempo_transicion)
          .style("opacity","1")
          .style("width", "100%")
          .style("height", "100%")
          .style("top","0%")
          .style("left","0%");

        d3.select("div#"+this.id)
          .select("img.img-5")
          .style("left",window.innerWidth>0?"0%":"0%")
          .style("top",window.innerWidth>0?"100%":"100%")
          .style("opacity","0")
          .transition()
          .delay(2*this.tiempo_transicion)
          .duration(1.5*this.tiempo_transicion)
          .style("opacity","1")
          .style("top","0%")
          .style("left","0%");
        
        d3.select("div#"+this.id)
          .select("img.img-5-1")
          .style("left",window.innerWidth>0?"0%":"0%")
          .style("top",window.innerWidth>0?"-100%":"-100%")
          .style("opacity","0")
          .transition()
          .delay(2*this.tiempo_transicion)
          .duration(2*this.tiempo_transicion)
          .style("opacity","1")
          .style("top","0%")
          .style("left","0%");
        

        d3.select("div#"+this.id)
          .selectAll("img.img-6")
          .style("bottom",window.innerWidth>0?"-30%":"0%")
          .style("opacity","0")
          .transition()
          .delay(2*this.tiempo_transicion)
          .duration(this.tiempo_transicion)
          .style("opacity","1")
          .style("bottom","0%")
        


      }
      else{
        d3.select("div#"+this.id)
          .transition()
          .duration(this.tiempo_transicion)
          .style("opacity","1");

        d3.select("div#"+this.id)
          .select("div.contenedor-fondo")
          .transition()
          .duration(this.tiempo_transicion)
          .style("width","0%");
        
          
      }
      
    },
  },
  data(){
    return {
      tiempo_transicion:1000
    }
  },
  mounted() {
    
  },
  methods: {
    paso_n(){}
      
  }
};
</script>

<style scoped lang="scss">
@media screen and (min-width: 769px)  {
  div.contenedor-portada-espacio-natural{
    position: absolute;
    top: 0;
    z-index: 401;
    width: 100%;
    height: 100vh;
    display: flex;
    div.contenedor-fondo{
      background:#021B24;
      width: 0%;
      transform: translateY(50px);
      margin: auto;
      position: relative;
      height: calc(100% );
      div.contenedor-imagenes{
        position: absolute;
        overflow: hidden;
        width: 100%;
        height: 100%;
        img{
          position: absolute;
          width:100%;
          max-width: 100%;
          height: 100%;
          left: 0;
          object-fit: cover;
          object-position: center;
        }
      }
    }
  }
  
}
@media screen and (max-width: 769px)  {
  div.contenedor-portada-espacio-natural{
    position: absolute;
    top: 0;
    z-index: 401;
    width: 100%;
    height: 100vh;
    display: flex;
    div.contenedor-fondo{
      background:#021B24;
      width: 0%;
      transform: translateY(50px);
      margin: auto;
      position: relative;
      height: calc(100% );
      div.contenedor-imagenes{
        position: absolute;
        overflow: hidden;
        width: 100%;
        height: 100%;
        img{
          position: absolute;
          width:100%;
          max-width: 100%;
          height: auto;
          left: 0;
          object-fit: cover;
          object-position: center;
          &.img-7{
            display: none;
          }
        }
      }
    }
  }

}
</style>
